import React, { PropTypes } from 'react';
import config from 'config';
import { Container, Row, Col } from 'react-grid-system';
import RaisedButton from 'material-ui/RaisedButton';
import AbstractEditForm from '../../common/AbstractEditForm';
import Input from '../../form/Input';
import ImageUpload from '../../form/ImageUpload';
import emptyFunction from 'fbjs/lib/emptyFunction';

class PlayersEditForm extends AbstractEditForm {
  static propTypes = {
    ...AbstractEditForm.propTypes,
    onAdd: PropTypes.func.isRequired
  };

  // eslint-disable-next-line no-unused-vars
  async formSubmitted(res) {
    this.props.onClose();
  }

  calculateAge(dateOfbirth) {
    const today = new Date();
    const birthDate = new Date(dateOfbirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age < 0) {
      return 0;
    }
    return age;
  }

  render() {
    let {
      fields: {
        name,
        file,
        number,
        age,
        nationality,
        position,
        foot,
        birthday,
        placeOfBirth
      },
      valid,
      submitting
    } = this.props;

    const onChangeBirthDate = value => {
      birthday.onChange(value);
      this.change('age', this.calculateAge(value));
    };

    return (
      <Container style={{ margin: 0, padding: 30 }}>
        <form onSubmit={this.processSubmit}>
          {this._renderHeader()}
          <Row>
            <Col lg={8} md={10} xs={12}>
              <Row>
                <Col md={6} xs={12}>
                  <ImageUpload
                    label="Picture"
                    format="image/jpeg"
                    imageWidth={200}
                    imageHeight={200}
                    required
                    crop={config.player.imageCrop}
                    {...file}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6} xs={12}>
                  <Input label="Name" required {...name} />
                </Col>
                <Col md={6} xs={12}>
                  <Input label="Number" required {...number} />
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Input
                    label="Date of birthday"
                    type="date"
                    {...birthday}
                    onChange={onChangeBirthDate}
                  />
                </Col>
                <Col md={6} xs={12}>
                  <Input label="Place of birth" {...placeOfBirth} />
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Input label="Age" type="number" max={100} {...age} />
                </Col>
                <Col md={6} xs={12}>
                  <Input label="Foot" {...foot} />
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Input label="Nationality" {...nationality} />
                </Col>
                <Col md={6} xs={12}>
                  <Input label="Position" {...position} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3} />
                <Col xs={12} sm={6}>
                  <RaisedButton
                    secondary={false}
                    fullWidth={true}
                    disabled={!valid || submitting}
                    onClick={this.processSubmit}
                    label="Save"
                  />
                </Col>
              </Row>
              <br />
            </Col>
          </Row>
        </form>
      </Container>
    );
  }
}

PlayersEditForm.defaultProps = {
  onAdd: emptyFunction,
  onClose: emptyFunction
};

export default PlayersEditForm;



// WEBPACK FOOTER //
// ./src/components/Players/PlayersEditForm/PlayersEditForm.jsx